import type { SubmitButtonProps } from '@rjsf/utils';
import { getSubmitButtonOptions } from '@rjsf/utils';
import styled, { css } from 'styled-components';
import Button from '../../deprecated-button/button';

const SubmitButtonTemplate = ({ uiSchema }: SubmitButtonProps) => {
  const { norender, submitText } = getSubmitButtonOptions(uiSchema);
  if (norender) {
    return;
  }
  return (
    <StyledButton type="submit" label={submitText ?? 'Submit'} width="auto" />
  );
};

export default SubmitButtonTemplate;

const StyledButton = styled(Button)`
  ${({ theme }) => css`
    margin-top: ${theme.spacing(5)};
  `}
`;
